import { render, staticRenderFns } from "./InquiriesList.vue?vue&type=template&id=5201cf14&"
import script from "./InquiriesList.vue?vue&type=script&lang=js&"
export * from "./InquiriesList.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InquiriesList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports